import React, { useState } from "react"
import classes from "./pricing.module.scss"
import styled from "@emotion/styled"
import Button from "@material-ui/core/Button"
import { colors } from "../../../library/constants/styles/colors"
import { withStyles } from "@material-ui/styles"
import { Link } from "react-router-dom"
import * as routes from "../../../library/constants/routes"
import CheckOutlined from "@material-ui/icons/CheckOutlined"
import IconButton from "@material-ui/core/IconButton"
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft"
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight"
import { InputLabel, useMediaQuery } from "@material-ui/core"
import { useSelector } from "react-redux"
import { devices } from "../../../library/constants/styles/responsive"
import { key } from "../../../library/utils/generateKey"
import PlainLink from "../../../components/ui/link"
import Select from "@material-ui/core/Select/Select"
import MenuItem from "@material-ui/core/MenuItem"
import { countries } from "../../../library/constants/states"
import FormControl from "@material-ui/core/FormControl/FormControl"
import PlanCard, { PlanContainer, PlanTitle } from "./PlanCard"

const WhiteButton = withStyles({
  root: {
    color: colors.white,
    borderColor: colors.white,
  },
})(Button)

const freePlan = {
  title: "FREE for anyone simplifying meeting calendaring and schedules",
  features: [
    "Create meetings without dates and times that calendars themselves; outside invitees can use your link to pick a time, inside users can use calendar intelligence to coordinate the best time for you and your invitees",
    "Social posting",
    "Create auto-cohorting multi-meetings that coordinate and calendar themselves with pre-instructions, auto-retargeting, and reminders. Learners cannot create Meets",
    "News feed",
    "Multi-meets tracking",
    "Create social and extra-credit Cred",
    "Create regular events for fellow users",
    "Sync with Microsoft Outlook or Google calendars",
    "Cannot create open time Holds for automatically slotting Meets in, Meets will use any open time from 8am-5pm in your time zone",
    "Input links video conferencing meets",
    "Personal profile page, finding friends, joining groups",
  ],
  comingSoonFeatures: [],
}

const plans = [
  {
    title: "Essentials",
    subtitle: "All Member Types",
    description:
      "For anyone who wants to make Holds – labeled open time which can also have minus-time breaks within it in order to control when the AI will place meetings, and to make Interest Groups.",
    description2: "",
    price: "$1.00",
    yearPrice: "$10",
    featuresBlockTitle: "Additional to Free level",
    features: [
      "Create open Holds for the time windows for when meetings should land, and when they shouldn't",
      "Create interest groups",
    ],
    comingSoonFeatures: [],
  },
  {
    title: "Teacher Premium",
    subtitle: "Educator Accounts Only",
    description:
      "For gig teachers creating a one-teacher-school group and inviting learners.",
    description2:
      "Educator accounts require 1-time background check fee of $20. ",
    price: "$5.00",
    yearPrice: "$50",
    featuresBlockTitle: "Additional to Free level",
    features: [
      "Create open Holds for the time windows for when meetings should land, and when they shouldn't",
      "Create one-teacher-school group and interest groups",
      "Create courses",
      "Create meets for any step of a course that auto-cohort",
      "Create a master calendar for your group",
      "Create partitioning of the master calendar of Segments (months), Sections (weeks), Rotations (daily), Blocks and Tracks",
      "Create grades and grade groups",
      "Create group holds for use in Courses",
      "Assign study schedules to members",
      "Create spaces",
      "Academic standards for all U.S. States and Canada",
      "Create official awarded Cred from Group (Grades/Marks, Certificates)",
    ],
    comingSoonFeatures: [
      "Create Plans for each learner",
      "Create reports for learners",
      "Courses sequencing",
      "Courses packaging into marketplace with ecommerce sales",
    ],
  },
  {
    title: "School Premium",
    subtitle: "Educator Accounts Only",
    description: "For schools using complex master schedules.",
    description2:
      "School or district, college or university must be authenticated to invite member learners.",
    price: "$1.50/seat",
    featuresBlockTitle: "Additional to Teacher level",
    features: [
      "Claim or create school and districts, associate schools under district",
      "Create pacing calendars",
      "Create units for pacing calendars to associate into Courses",
      "Multi-level calendaring (District:Schools)",
      "Create official awarded Cred from Group (Grades/Marks, Certificates, Diplomas and Degrees)",
    ],
    calculation: {
      options: [
        50, 100, 250, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000,
        6000, 7000, 8000, 9000, 10000, 12000, 14000, 16000, 18000, 20000, 25000,
        30000, 40000, 50000, 75000, 100000, 150000, 200000, 250000, 300000,
      ],
      priceLabel: "seat monthly",
    },
    comingSoonFeatures: [
      "Create Knowplans for each learner",
      "Create reports for learners",
      "Featured product direct integration into Courses",
      "Invenstory, roll-up of records keeping and product licensing tracking",
      "Single Sign-On for member accounts input",
      "Rostering integrations",
      "Advanced data views school-wide",
      "Custom integrations and security",
    ],
  },
  {
    title: "Company Premium",
    subtitle: "Representative Accounts Only",
    description:
      "For companies wanting to offer automatic demo scheduling to member types.",
    description2:
      "Companies wanting to offer demos to the learner type or under-age must be authenticated.",
    price: "$9.00",
    yearPrice: "$90",
    featuresBlockTitle: "Additional to Free level",
    features: [
      "Create open Holds for the time windows for when meetings should land, and when they shouldn't",
      "Create a company group and interest groups",
      "Schedule demo function",
      "Group calendar viewed by admins and staff",
      "Unlimited product tiles and pages associated to Group",
    ],
    comingSoonFeatures: [
      "eCommerce accounts and payments with license tracking",
      "Advertising boosts and blasts",
      "Story posting",
    ],
  },
]

// const mobilePlans = flattenDeep(plans).map((p) => [p])

const PricingPage = () => {
  const { isLoggedIn } = useSelector(({ auth }) => auth)
  const isMobile = useMediaQuery("(max-width:599px)")
  const step = 1
  // const step = isMobile ? 1 : 4
  // const usedPlans = !isMobile ? plans : mobilePlans
  const [page, setPage] = useState(0)

  const [offset, setOffset] = useState(0)

  const [currentPrice, setCurrentPrice] = useState(1.5)
  const [seats, setSeats] = useState(50)

  const navigatePrev = () => {
    if (offset === 0) return
    setOffset((prevState) => prevState - step)
  }

  const navigateNext = () => {
    if (offset >= plans.length) return
    setOffset((prevState) => prevState + step)
  }

  const navigation = isMobile ? (
    <>
      <span className={"mr15 font-16"}>see more</span>
      <IconButton
        aria-label="Previous"
        onClick={navigatePrev}
        disabled={offset === 0}
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        aria-label="Next"
        onClick={navigateNext}
        disabled={offset + step >= plans.length}
      >
        <KeyboardArrowRight />
      </IconButton>
    </>
  ) : (
    <>
      <div>
        {offset !== 0 && (
          <Button
            color={"primary"}
            aria-label="Previous"
            onClick={navigatePrev}
            startIcon={<KeyboardArrowLeft />}
          >
            See previous levels
          </Button>
        )}
      </div>
      <div>
        {offset + 4 < plans.length && (
          <Button
            color={"primary"}
            aria-label="Next"
            onClick={navigateNext}
            endIcon={<KeyboardArrowRight />}
          >
            See next levels
          </Button>
        )}
      </div>
    </>
  )

  return (
    <div className={classes.page}>
      <div>
        <Row bg={colors.grey7}>
          <div className="container">
            <div className="flexgrid full-width">
              <FreePlanContainer>
                <PlanContainer>
                  <PlanTitle>{freePlan.title}</PlanTitle>
                  <FreePlanFeatures>
                    {freePlan.features.map((f) => (
                      <div className={"mb15 f"} key={f}>
                        <CheckOutlined color={"primary"} className={"mr15"} />
                        <span>{f}</span>
                      </div>
                    ))}
                  </FreePlanFeatures>
                </PlanContainer>
              </FreePlanContainer>

              <div className={`full-width f aic jcfe pt15 pb30`}>
                {navigation}
              </div>
              <Container>
                {plans
                  .slice(offset, isMobile ? offset + 1 : offset + 4)
                  .map((p, i) => (
                    <PlanCard plan={p} key={i} />
                  ))}
              </Container>
            </div>
          </div>
        </Row>
      </div>
    </div>
  )
}

const Row = styled.div`
  display: flex;
  align-items: center;
  min-height: 54px;
  padding: ${(props) => props.padding || "15px 0"};
  background-color: ${(props) => props.bg || colors.white};
`
const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  //margin-bottom: 100px;

  @media ${devices.xs} {
    padding-inline: 15px;
    grid-template-columns: 1fr;
  }
`

const FreePlanContainer = styled.div`
  @media ${devices.xs} {
    padding-inline: 15px;
  }
`

const FreePlanFeatures = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-top: 30px;

  @media ${devices.xs} {
    grid-template-columns: 1fr;
  }
`

export default PricingPage
